// router/index.js
import {
	createRouter,
	createWebHistory
} from 'vue-router'
import indexView from './../components/indexView.vue'
import productsView from './../components/productsView.vue'
import aboutUsView from './../components/aboutUsView.vue'
import newsView from './../components/newsView.vue'
const routes = [{
		path: '/',
		name: 'Home',
		component: indexView
	},
	{
		path: '/products',
		name: 'poroducts',
		component: productsView
	},
	{
		path: '/aboutUs',
		name: 'aboutUs',
		component: aboutUsView
	},
	{
		path: '/news',
		name: 'news',
		component: newsView
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes,
})
export default router